<template>
  <section
    :class="$style.joinWhy"
    :style="{
      backgroundImage: `url('${assets.WhyBackground}')`,
    }"
  >
    <JoinHeading
      :level="1"
      class="text-white mb-7 text-center"
    >
      {{ $t('join.section.why.title') }}
    </JoinHeading>

    <PageCollectionCarousel
      align="center"
    >
      <GraphicalCardItem
        v-for="item in items"
        :key="item.image"
        :item="item"

        :class="$style.item"
        class="text-center bg-white"
      />
    </PageCollectionCarousel>
  </section>
</template>

<script lang="ts">
import PageCollectionCarousel from '@/scripts/pages/onepager/components/PageCollectionCarousel.ts.vue';
import { JoinBaseComponent } from '../common/JoinBaseComponent';
import JoinHeading from '../common/JoinHeading.ts.vue';
import GraphicalCardItem, { GraphicalCardItemProps } from '../common/GraphicalCardItem.ts.vue';
import { WhyBackground, WhyGraphics } from '../assets/media';
import { LocaleItem } from '../types/LocaleItem';

const itemGraphic = [
  WhyGraphics.globe,
  WhyGraphics.clapperboard,
  WhyGraphics.trophy,
];

export default JoinBaseComponent.extend({
  components: {
    JoinHeading,
    PageCollectionCarousel,
    GraphicalCardItem,
  },
  data() {
    const items: GraphicalCardItemProps[] = (this.$t('join.section.why.items') as LocaleItem[])
      .map((item, index) => ({
        image: itemGraphic[index],
        title: item.title,
        paragraphs: item.paragraphs,
      }))
    ;

    return {
      assets: {
        WhyBackground,
      },
      items,
    };
  },
});
</script>

<style module lang="scss">
.joinWhy {
  padding-top: 4rem;
  padding-bottom: 4rem;
  background-position: 50% 103.5%;
  min-height: 840px;
  background-repeat: no-repeat;
}

.scroller {
  overflow: auto;
  gap: 1rem;
}

.item {
  $width: 320px;
  min-width: $width;
  max-width: $width;
  width: $width;

  min-width: Min($width, calc(100vw - 68px));
  max-width: Min($width, calc(100vw - 68px));
  width: Min($width, calc(100vw - 68px));
}
</style>
